import React, { useState } from "react";
import { useEffect } from "react";
import useAuth from "../hooks/useAuth";
import axiosInstance from '../utilities/axiosInstance';
import { Listbox } from '@headlessui/react';
import { FaChevronDown, FaCheck } from 'react-icons/fa';
import clsx from 'clsx';
import { showAlert } from "./AlertPopup";
import { FaUser, FaEnvelope } from "react-icons/fa";
import AllProfileData from "../components/AllProfileData"

const CreateProfileManager = () => {
  const [formData, setFormData] = useState({
    id: [],
    fullName: "",
    email: "",
    role: "",
  });
  const [selected, setSelected] = useState([]);
  const [numOfWorkers, setNumOfWorkers] = useState([]);
  const [email, setEmail] = useState("");
  const [validationMessage, setValidationMessage] = useState("");
  const [fullNameError, setFullNameError] = useState(false);
  const { auth } = useAuth();
  const [reloadTrigger, setReloadTrigger] = useState(0);

  const roles = [
    { id: '', name: 'Select Role' },
    { id: '3', name: 'Tagger' },
    { id: '4', name: 'Reviewer' },
  ];

  const selectedRole = roles.find(role => role.id === formData.role) || roles[0];

  const onRoleChange = (value) => {
    handleChange({ target: { name: 'role', value: value.id } });
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const localPart = email.substring(0, email.indexOf("@"));
    const localPartInvalidSymbols = /[^\w.]/;
    const atIndex = email.indexOf("@");
    const domainPart = email.substring(atIndex + 1);
    const dotIndex = email.lastIndexOf(".");
    if (!emailRegex.test(email)) {
      return false;
    }
    if (localPart.startsWith(".") || localPart.startsWith("_")) {
      return false;
    }
    if (localPartInvalidSymbols.test(localPart)) {
      return false;
    }
    if (localPart.includes("..")) {
      return false;
    }
    if (/\d/.test(domainPart)) {
      return false;
    }
    if (dotIndex === email.length - 1 || dotIndex < atIndex) {
      return false;
    }
    return true;
  };

  const handleChange = (e) => {
    /* const select = document.getElementById('projectNames');
        let selectedValues = [...select.options]
            .filter(option => option.selected)
            .map(option => option.value);
        setSelected(selectedValues) */

    if (e.target.name) {
      if (e.target.name == "email") {
        setEmail(e.target.value);
      }
      setFormData(() => ({
        ...formData,
        [e.target.name]: e.target.value,
      }));
      if (formData.fullName.length <= 25 && e.target.name == "fullName") {
        setFormData(() => ({
          ...formData,
          [e.target.name]: e.target.value.slice(0, 25),
        }));
      }
      if (e.target.value.length >= 25 && e.target.name != "email") setFullNameError(true);
      else setFullNameError(false);
    }
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  if (validateEmail(email)) {
    setValidationMessage("");

    formData.id = selected;
    const randomNumber = Math.floor(Math.random() * 10000);
    const username = formData.fullName.split(" ").join("") + "." + randomNumber;
    const password = Math.random().toString(36).slice(-8);

    const formDataWithDetails = {
      ...formData,
      name: formData.fullName,
      fullname: formData.fullName,
      username,
      password,
      confirmPassword: password,
    };

    try {
      const response = await axiosInstance.post(`/create/profile`, formDataWithDetails);
      const data = response.data;
      showAlert(data.message, "success");

      setFormData({
        id: [],
        fullName: "",
        email: "",
        role: "",
        name: "",
        username: "",
        password: "",
        confirmPassword: "",
      });

      // ✅ Trigger reload of AllProfileData
      setReloadTrigger(prev => prev + 1);

    } catch (err) {
      showAlert(err.message, "error");
    }

  } else {
    setValidationMessage("Invalid email, please provide valid email.");
  }
};

  const [projectList, setProjectList] = useState([]);

  /**
   * Created By: Vikas Bose | 08/02/2024
   */
  const getListOfManager = async () => {
    await axiosInstance
      .get(`/listoworker`, {
        params: {
          role_id: "3,4",
        },
      })
      .then((response) => {
        setNumOfWorkers(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    const fetchProjects = async () => {
      const response = await axiosInstance.get(`/allprojects`);
      // const data = await response.json();
      setProjectList(response.data);
    };
    fetchProjects();
    getListOfManager();
  }, []);

  return (
    <>
      <div className="border-b border-gray-d-200 dark:border-white flex justify-between">
        <h2 className="font-poppins font-medium text-[20px] leading-[100%] tracking-[0%] text-gray-main pb-3 dark:text-white">Create Profile (Tagger & Reviewer)</h2>
        <h2 className="font-poppins font-medium text-[20px] leading-[100%] tracking-[0%] text-[#00B4D2] pb-3 dark:text-white">
          Welcome{" "}
          {auth.profile_name !== "null"
            ? auth.profile_name
            : auth.profile_username}{" "}
          - Create Profile Manager{" "}
        </h2>
      </div>
      <div className="mx-auto mt-11">
        <form onSubmit={handleSubmit} id="create-task" className="w-full">
          <div id="profile_content_wrapper" className="flex flex-wrap items-center justify-start gap-6">

            <div className="flex flex-col">
              <div className="relative">
                <FaUser className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <input
                  type="text"
                  name="fullName"
                  value={formData.fullName}
                  placeholder="Enter Full Name"
                  onChange={handleChange}
                  required
                  className="min-w-[263px] h-[40px] pl-10 pr-5 rounded-[22px] bg-white border border-gray-300 shadow-sm focus:outline-none focus:ring-1 focus:ring-primary-color focus:border-primary-color font-poppins text-[15px] text-gray-main"
                />
              </div>
              {fullNameError && showAlert("Max full name limit reached.", "error")}
            </div>

            {/* Email Input with Icon */}
            <div className="flex flex-col ">
              <div className="relative">
                <FaEnvelope className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter Email Address"
                  required
                  className="min-w-[263px] h-[40px] pl-10 pr-5 rounded-[22px] bg-white border border-gray-300 shadow-sm focus:outline-none focus:ring-1 focus:ring-primary-color focus:border-primary-color font-poppins text-[15px] text-gray-main"
                />
              </div>
              {validationMessage && showAlert("Please enter a valid Email address", "error")}
            </div>

            {/* Role */}
            <div className="flex flex-col">
              <div className="relative font-poppins text-[15px]">
                <Listbox value={selectedRole} onChange={onRoleChange}>
                  <div className="relative w-[250px]">
                    <Listbox.Button className="relative w-full h-[40px] cursor-pointer rounded-[22px] bg-white border border-gray-300 pl-5 pr-10 text-left shadow-sm focus:outline-none focus:ring-1 focus:ring-primary-color focus:border-primary-color text-gray-main">
                      <span className="block truncate">{selectedRole.name}</span>
                      <span className="pointer-events-none absolute inset-y-0 right-3 flex items-center">
                        <FaChevronDown className="h-3 w-3 text-gray-400" />
                      </span>
                    </Listbox.Button>

                    <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-[10px] bg-gray-decent py-1 text-[14px] shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                      {roles
                        .filter(role => role.id !== '') // <-- Exclude "Select Role" from dropdown
                        .map((role, index) => (
                          <Listbox.Option key={role.id} value={role}>
                            {({ active }) => (
                              <div
                                className={clsx(
                                  "relative cursor-pointer select-none py-2 pl-2 pr-8 flex justify-between items-center",
                                  {
                                    "border-b border-[#28325A26]": index !== roles.length - 2, // -2 because one item is filtered out
                                    "text-deep-blue border-deep-blue": active,
                                    "text-gray-900": !active,
                                  }
                                )}
                              >
                                <span>{role.name}</span>
                                {(formData.role === role.id || active) && (
                                  <span className="absolute right-2 flex items-center justify-center h-[20px] w-[20px] bg-deep-blue rounded-full">
                                    <FaCheck className="text-white text-[10px]" />
                                  </span>
                                )}
                              </div>
                            )}
                          </Listbox.Option>
                        ))}

                    </Listbox.Options>
                  </div>
                </Listbox>
              </div>
            </div>

            {/* Submit Button */}
            <div className="flex flex-col justify-end">
              <button
                type="submit"
                className="w-[150px] h-[40px] rounded-[22px] px-[24px] py-[10px] text-white transition-all duration-1000 bg-gradient-to-r from-[#C300A0] to-[#00B4D2] hover:from-[#00B4D2] hover:to-[#C300A0]"
              >
                Add Profile
              </button>
            </div>
          </div>
        </form>

        <AllProfileData reload={reloadTrigger} />
      </div>
    </>
  );
};
export default CreateProfileManager;
